export default {
  functions: {
    functionCode: '功能编号',
    functionName: '功能名称',
    functionId: '功能ID',
    ChooseSystem: '系统选择',
    SystemName: '系统名称',
    Prefix: '前缀',
    ASP: 'ASP',
    AddFunction: '新增功能',
    EditFunction: '修改功能信息',
    RelationUrl: '关联Url',
    ChooseMenuUrl: '菜单Url选择',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/base/functions.js